import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row, Modal } from "react-bootstrap";
import {
  OutlinedInput,
  FormControl,
  Select,
  InputLabel,
} from "@material-ui/core";
import { ReusableOnboardingButton } from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ToggleButtonWithYesNo } from "../../../../AllButton/ToggleButtonReuse";

import SVG from "react-inlinesvg";
import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { NewInputText } from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  get_vendor_added_templates,
  add_new_template_vendor,
  add_new_choice_template_vendor,
  update_item_menu_setup,
} from "../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import FastFoodCustomizationItem from "./FastFoodCustomizationItem";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import SlidingComponent from "../../../../../../../reusableComponents/slidingToggleComponent/SlidingComponent";

const validate = (values) => {
  const errors = {};

  if (values.nutritional_info && !values.calories) {
    errors.calories = "Please enter calories";
  }

  if (values.allergy_info && values.allergies.length === 0) {
    errors.allergies = "Please select allergies";
  }
  return errors;
};

const Customization = (props) => {
  const back = () => {
    props.onChange(7);
    window.scroll(0, 0);
  };
  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    formData.currentState = 6;
    formData.runingTrack = 7;
    props.update_item_menu_setup(props.activeItemId, formData, token, back);
  };
  const onSuccess = () => {
    props.onChange(9);
    window.scroll(0, 0);
  };
  const [showAddChoice, setShowAddChoice] = useState(false);
  const handleAddChoice = (templateId, data) => {
    if (templateId) {
      setTemplateId(templateId);
      formik.setFieldValue("name", data.name);
      formik.setFieldValue("mandatory_item", data.mandatory_item);
      formik.setFieldValue("single_select", data.single_select);
      formik.setFieldValue("allow_adding_multiple", data.allow_adding_multiple);
      formik.setFieldValue("save_as_template", data.save_as_template);
    } else {
      formik.resetForm();
      setTemplateId("");
    }
    setShowAddChoice(true);
  };
  const handleCloseAddChoice = () => setShowAddChoice(false);
  const [showCustomizedTemplates, setShowCustomizedTemplates] = useState(false);
  const handleCustomizedTemplates = () => setShowCustomizedTemplates(true);
  const handleCloseCustomizedTemplates = () =>
    setShowCustomizedTemplates(false);
  const [showAddOptionItem, setShowAddOptionItem] = useState(false);
  const [templateId, setTemplateId] = useState("");
  const [itemId, setItemId] = useState("");

  const handleAddOptionItem = (templateId, itemId, itemData) => {
    setTemplateId(templateId);
    if (itemId) {
      setItemId(itemId);
      formikAddOptions.setFieldValue("name", itemData.name);
      formikAddOptions.setFieldValue("one_size", itemData.one_size);
      formikAddOptions.setFieldValue("price", itemData.price);
      formikAddOptions.setFieldValue("veg", itemData.veg);
      formikAddOptions.setFieldValue("food_type", itemData.food_type);
      formikAddOptions.setFieldValue(
        "nutritional_info",
        itemData.nutritional_info
      );
      formikAddOptions.setFieldValue("calories", itemData.calories);
      formikAddOptions.setFieldValue("allergy_info", itemData.allergy_info);
      formikAddOptions.setFieldValue("allergies", itemData.allergies);
    } else {
      formikAddOptions.resetForm();
    }
    setShowCustomizedTemplates(false);
    setShowAddOptionItem(true);
  };
  const handleCloseAddOptionItem = () => setShowAddOptionItem(false);

  const [state, setState] = useState([{ SelectTemplate: "" }]);

  const onChangeItemCustomize = () => {
    formikCutomizable.setFieldValue(
      "customizable",
      !formikCutomizable.values.customizable
    );
  };

  const onSuccessAddChoice = (msg) => {
    const token = props.auth.user.accessToken;
    const vendorId = props.auth.user.VendorUser._id;
    props.get_vendor_added_templates(vendorId, token);
    setShowAddChoice(false);
    setShowAddOptionItem(false);
    Alert.success(`<h4>${msg}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const onChangeMandtory = (status) => {
    formik.setFieldValue("mandatory_item", status);
  };

  const onChangeSingleSelect = (status) => {
    formik.setFieldValue("single_select", status);
  };

  const formikCutomizable = useFormik({
    initialValues: {
      customizable: false,
      addOns: [],
    },

    onSubmit: (values) => {
      //props.onChange(9);
      let formData = {};
      formData = { ...formikCutomizable.values };
      const token = props.auth.user.accessToken;
      formData.currentState = 8;
      formData.runingTrack = 9;
      props.update_item_menu_setup(
        props.activeItemId,
        formData,
        token,
        onSuccess
      );
    },
  });

  const onClickAddNewChoice = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      mandatory_item: false,
      single_select: false,
      allow_adding_multiple: false,
      save_as_template: false,
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(256, "Must be 256 characters or less")
        .required("Please enter name"),
    }),
    onSubmit: (values) => {
      let msg = "Template Added sucessfully";
      //props.onChange(9);
      const token = props.auth.user.accessToken;
      let formData = {};
      formData = { ...values };
      if (templateId.length > 2) {
        let msg = "Template Edited sucessfully";
        props.add_new_choice_template_vendor(
          templateId,
          formData,
          token,
          onSuccessAddChoice,
          msg,
          onUpdateFormik
        );
      } else {
        props.add_new_template_vendor(
          formData,
          token,
          onSuccessAddChoice,
          msg,
          onUpdateFormik
        );
        //window.scroll(0, 0);
      }
    },
  });

  const onUpdateFormikDelete = (id) => {
    let tempData = formikCutomizable.values.addOns.filter((item) => {
      return id !== item._id;
    });
    formikCutomizable.setFieldValue("addOns", tempData);
  };

  const onUpdateFormikDeleteItem = (id, data) => {
    let tempData = formikCutomizable.values.addOns;
    let updateData = [];
    for (let i = 0; i < tempData.length; i++) {
      if (id === tempData[i]._id) {
        updateData.push(data); // edit data
      } else {
        updateData.push(tempData[i]); // existing  data
      }
    }
    formikCutomizable.setFieldValue("addOns", updateData);
  };

  const onUpdateFormik = (data) => {
    let edit = false;
    let tempData = formikCutomizable.values.addOns;
    let updateData = [];
    if (tempData.length >= 1) {
      for (let i = 0; i < tempData.length; i++) {
        if (data._id === tempData[i]._id) {
          edit = true;
          updateData.push(data); // edit data
        } else {
          updateData.push(tempData[i]); // existing  data
        }
      }
    }
    if (!edit) {
      updateData.push(data); // new data
    }

    formikCutomizable.setFieldValue("addOns", updateData);
  };

  const onChangeFoodType = (id) => {
    formikAddOptions.setFieldValue("food_type", id);
  };

  const onChangeSize = (status) => {
    formikAddOptions.setFieldValue("one_size", status);
  };

  const onChangeVegNon = (status) => {
    formikAddOptions.setFieldValue("veg", status);
  };

  const onChangeNutrutionalInfo = () => {
    formikAddOptions.setFieldValue(
      "nutritional_info",
      !formikAddOptions.values.nutritional_info
    );
  };

  const onChangeAllergyInfo = () => {
    formikAddOptions.setFieldValue(
      "allergy_info",
      !formikAddOptions.values.allergy_info
    );
  };

  const onChangeAddRemoveAllergy = (titleName) => {
    let updateData = formikAddOptions.values.allergies;
    if (updateData.includes(titleName)) {
      let filterData = updateData.filter((item) => {
        return item !== titleName;
      });
      updateData = filterData;
    } else {
      updateData.push(titleName);
    }
    formikAddOptions.setFieldValue("allergies", updateData);
  };

  const onClickSave = (e) => {
    e.preventDefault();
    formikAddOptions.handleSubmit();
  };

  const formikAddOptions = useFormik({
    initialValues: {
      //item_customize: false,

      name: "",
      one_size: false,
      price: "",
      veg: true,
      food_type: "",
      nutritional_info: false,
      calories: "",
      allergy_info: false,
      allergies: [],
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(64, "Must be 64 characters or less")
        .required("Please enter name"),
      price: yup.number().required("Please enter price"),
      food_type: yup.string().required("Please select food type"),
    }),
    validate,

    onSubmit: (values) => {
      //props.onChange(9);
      let msg = "Item added sucessfully";
      let dataToAppend = props.vendor_templates;
      let optionsData = [];
      for (let i = 0; i < dataToAppend.length; i++) {
        if (dataToAppend[i]._id === templateId) {
          for (let j = 0; j < dataToAppend[i].options.length; j++) {
            optionsData.push(dataToAppend[i].options[j]);
          }
        }
      }
      if (itemId) {
        // this is for edit

        let updateOptionData = optionsData.filter((item) => {
          return item._id !== itemId;
        });
        msg = "Item edited sucessfully";
        optionsData = updateOptionData;
      }
      optionsData.push(values);
      const token = props.auth.user.accessToken;
      let formData = {};
      formData.options = optionsData;
      props.add_new_choice_template_vendor(
        templateId,
        formData,
        token,
        onSuccessAddChoice,
        msg,
        onUpdateFormik
      );

      // window.scroll(0, 0);
    },
  });

  const [vendorAllTemplates, setVendorAllTemplates] = useState([]);
  const [templateOptionsData, setTemplateOptionsData] = useState([]);
  const selecthandleChange = (e) => {
    let templateId = e.target.value;
    setTemplateId(e.target.value);
    for (let i = 0; i < vendorAllTemplates.length; i++) {
      if (templateId === vendorAllTemplates[i]._id) {
        let prepareData = [];
        for (let j = 0; j < vendorAllTemplates[i].options.length; j++) {
          let data = vendorAllTemplates[i].options[j];
          data.value = false;
          prepareData.push(data);
        }
        //setTemplateOptionsData(vendorAllTemplates[i].options);
        setTemplateOptionsData(prepareData);
        break;
      }
    }
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeAddCheck = (id, status) => {
    let data = [];

    for (let i = 0; i < templateOptionsData.length; i++) {
      if (id === templateOptionsData[i]._id) {
        let temp = templateOptionsData[i];
        temp.value = !status;
        data.push(temp);
      } else {
        data.push(templateOptionsData[i]);
      }
    }
    setTemplateOptionsData(data);
  };

  const onClickDone = (e) => {
    e.preventDefault();

    let templateData = [];
    let optionsData = [];
    for (let i = 0; i < vendorAllTemplates.length; i++) {
      if (vendorAllTemplates[i]._id === templateId) {
        templateData.push(vendorAllTemplates[i]);
        for (let j = 0; j < templateOptionsData.length; j++) {
          if (templateOptionsData[j].value) {
            optionsData.push(templateOptionsData[j]);
          }
        }
      }
    }
    templateData[0].options = optionsData;
    let formikDataForAddOns = formikCutomizable.values.addOns;
    let getAllCategoryId = [];
    for (let i = 0; i < formikDataForAddOns.length; i++) {
      getAllCategoryId.push(formikDataForAddOns[i]._id);
    }

    if (getAllCategoryId.includes(templateData[0]._id)) {
      for (let i = 0; i < formikDataForAddOns; i++) {
        if (templateData[0]._id === formikDataForAddOns[i]._id) {
          formikDataForAddOns[i] = templateData[0];
          break;
        }
      }
    } else {
      formikDataForAddOns.push(templateData[0]);
    }

    formikCutomizable.setFieldValue("addOns", formikDataForAddOns);
    // const token = props.auth.user.accessToken;
    // const vendorId = props.auth.user.VendorUser._id;
    // props.get_vendor_added_templates(vendorId, token);
    setTemplateOptionsData([]);
    setState([]);
    setVendorAllTemplates([]);
    handleCloseCustomizedTemplates();
  };

  const onClickAssignTemplate = () => {
    let data = [...props.vendor_templates];
    let showSavedTemplatesOnly = [];
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].save_as_template) {
          showSavedTemplatesOnly.push(data[i]);
        }
      }
      setTemplateOptionsData([]);
      setState([]);
      setVendorAllTemplates(showSavedTemplatesOnly);
    }
    handleCustomizedTemplates();
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    const vendorId = props.auth.user.VendorUser._id;
    props.get_vendor_added_templates(vendorId, token);
  }, []);
  const [foodType, setFoodType] = useState([]);

  const [allergyInfo, setAllergyInfo] = useState([]);

  useEffect(() => {
    let data = [];
    for (let i = 0; i < props.food_type.length; i++) {
      if (props.food_type[i].status === "APPROVED") {
        data.push({
          _id: props.food_type[i]._id,
          title: props.food_type[i].title,
        });
      }
    }

    setFoodType(data);
  }, [props.food_type]);

  useEffect(() => {
    let data = [];
    for (let i = 0; i < props.allergy_info.length; i++) {
      if (props.allergy_info[i].status === "APPROVED") {
        data.push({
          title: props.allergy_info[i].title,
          icon: props.allergy_info[i].icon,
        });
      }
    }
    setAllergyInfo(data);
  }, [props.allergy_info]);

  const onClickNext = () => {
    formikCutomizable.handleSubmit();
  };

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      formikCutomizable.setFieldValue("customizable", data.customizable);
      formikCutomizable.setFieldValue("addOns", data.addOns);
      //formikCutomizable.setFieldValue("addOns", []);
    }
  }, [props.menuCategoryItems]);

  return (
    <React.Fragment>
      {console.log("-----")}
      {console.log(props.vendor_templates)}
      {console.log("---END---")}
      {console.log("-----Formik-----")}
      {console.log(formikCutomizable.values.addOns)}
      {console.log("---Formik---END---")}
      <Form>
        <div className="mb-4">
          <TopTextReusableComponent
            headingText="New Item"
            headingParagraph="Manage your food items"
          />
        </div>
        <div className="bg-gray px-3 py-2">
          <Row>
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="f12-700 pr-3" style={{ width: 140 }}>
                  Ext Item ID :
                </div>
                <FormControl className={"w-100 bg-white"} variant="outlined">
                  <OutlinedInput
                    disabled
                    value={
                      props.menuCategoryItems && props.menuCategoryItems.ext_id
                    }
                  />
                </FormControl>
              </div>
            </Col>
          </Row>
        </div>
        <div
          className="displayItemsName f11-400 enRadius5 my-4"
          style={{ height: 50 }}
        >
          {props.menuCategoryItems && props.menuCategoryItems.name}
        </div>
        <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
          <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
            Is Item Customizable?
          </div>
          <div className="col-4 col-md-4 col-lg-6">
            <ToggleButtonWithYesNo
              checkedBox={formikCutomizable.values.customizable}
              onChange={() => onChangeItemCustomize()}
            />
          </div>
        </div>
        <>
          {formikCutomizable.values.customizable ? (
            <>
              <div className="f14-700 mb-2">Choices & Addons</div>
              <div className="mb-4 f11-400 opacity5">
                You can select from the predefined templates to customize item
                or you can add new categories and customize items
              </div>
              <div className="d-flex flex-wrap align-items-center pb-4">
                <Button
                  variant="dark"
                  className="btn-md f13_400_HelveticaNeue"
                  onClick={() => handleAddChoice()}
                >
                  Add Choice
                </Button>
                <div className="f12-500 mx-3">Or</div>
                <button
                  type="button"
                  className={
                    "add-button-icon-reusable add-button-icon-reusable-blue"
                  }
                  onClick={() => onClickAssignTemplate()}
                >
                  Assign Template
                </button>
              </div>

              {/* {formikCutomizable.values.addOns.map((item, index) => ( */}

              {/* {props.vendor_templates.map((item, index) => ( */}
              {formikCutomizable.values.addOns.map((item, index) => (
                <FastFoodCustomizationItem
                  key={index}
                  data={item}
                  onUpdateFormikDeleteItem={(id, data) =>
                    onUpdateFormikDeleteItem(id, data)
                  }
                  onUpdateFormikDelete={(id) => onUpdateFormikDelete(id)}
                  onEditChoice={(id, data) => handleAddChoice(id, data)}
                  onClick={(templateId, itemId, itemData) =>
                    handleAddOptionItem(templateId, itemId, itemData)
                  }
                />
              ))}
            </>
          ) : (
            <> </>
          )}
        </>
        <div className="onboarding-map-setup-screen-autodetect-button mt-5">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="btn-lg btn btn-outline-secondary"
            buttonText="Back"
            buttonType="button"
            onClick={() => onClickBack()}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
            buttonText="Save and Next"
            buttonType="button"
            //onClick={onSubmit}
            onClick={() => onClickNext()}
          />
        </div>
      </Form>
      <Modal
        show={showAddChoice}
        onHide={handleCloseAddChoice}
        centered
        size="lg"
      >
        <Modal.Header className="px-lg-5 pt-lg-5 border-0" closeButton>
          <Modal.Title className="f18-700">
            Add-On Choice Name to Create a Template
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-lg-5 pb-lg-5">
          <Form>
            <div className="f16-700 pb-1">
              Add-On Choice Name to Create a Template and Reuse
            </div>
            <Row>
              <Col lg={10}>
                <NewInputText
                  controlClass={"name"}
                  placeholder="e.g. Crust Base, Premium Toppings,"
                  extraClass={`mb-3 ${
                    formik.errors.name && formik.touched.name ? "enError" : ""
                  }`}
                  name="name"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.name && formik.touched.name ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.name}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="f16-700 pb-3">
                  Is item mandatory or optional?
                </div>
                <div className="d-flex align-items-center pb-4">
                  <label className="enRadioWithText small mr-4">
                    <div className="f13-500">Mandatory</div>
                    <input
                      type="radio"
                      name="mandatory_item"
                      checked={formik.values.mandatory_item === true}
                      onChange={() => onChangeMandtory(true)}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="enRadioWithText small mr-4">
                    <div className="f13-500">Optional</div>
                    <input
                      type="radio"
                      name="mandatory_item"
                      checked={formik.values.mandatory_item === false}
                      onChange={() => onChangeMandtory(false)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="f16-700 pb-3">
                  Is this item Single Selection or Multi Selection?
                </div>
                <div className="d-flex align-items-center pb-4">
                  <label className="enRadioWithText small mr-4">
                    <div className="f13-500">Single Select</div>
                    <input
                      type="radio"
                      name="single_select"
                      checked={formik.values.single_select === true}
                      onChange={() => onChangeSingleSelect(true)}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="enRadioWithText small mr-4">
                    <div className="f13-500">Multi Select</div>
                    <input
                      type="radio"
                      name="single_select"
                      checked={formik.values.single_select === false}
                      onChange={() => onChangeSingleSelect(false)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </Col>
              <Col md={6}>
                <div className="d-flex row mb-3">
                  <Col md={2} className="f12-700">
                    Active{" "}
                  </Col>
                  <Col md={8} className="d-flex">
                    No &nbsp;
                    <SlidingComponent
                      name="status"
                      currentState={false}
                      type={"checkbox"}
                      toggleclass={
                        "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                      }
                      toggleinputclass={
                        "toggle__switch vendor-super-admin-toggle"
                      }
                      onChange={() => {}}
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={true}
                    />
                    &nbsp;Yes
                  </Col>
                </div>
                <div className="d-flex row mb-3">
                  <Col md={2} className="f12-700">
                    Available{" "}
                  </Col>
                  <Col md={8} className="d-flex">
                    No &nbsp;
                    <SlidingComponent
                      name="status"
                      currentState={false}
                      type={"checkbox"}
                      toggleclass={
                        "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                      }
                      toggleinputclass={
                        "toggle__switch vendor-super-admin-toggle"
                      }
                      onChange={() => {}}
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={true}
                    />
                    &nbsp;Yes
                  </Col>
                </div>
              </Col>
            </Row>

            <div className="d-flex align-items-center pb-3">
              <Form.Check
                label="1"
                inline
                className="enCheckBoxOnly d-grid"
                name="allow_adding_multiple"
                checked={formik.values.allow_adding_multiple}
                onChange={formik.handleChange}
              />
              <div className="f13-500">
                Allow adding same choice multiple times
              </div>
            </div>
            <div className="d-flex align-items-center pb-3">
              <Form.Check
                label="1"
                inline
                className="enCheckBoxOnly d-grid"
                name="save_as_template"
                checked={formik.values.save_as_template}
                onChange={formik.handleChange}
              />
              <div className="f13-500">Save as a template</div>
            </div>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn150px btn btn-outline-secondary"
                buttonText="Cancel"
                buttonType="button"
                onClick={handleCloseAddChoice}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn150px btn btn-danger btn-lg ml-3 "
                buttonText="Save"
                buttonType="button"
                // onClick={handleCloseAddChoice}
                onClick={(e) => onClickAddNewChoice(e)}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        show={showAddOptionItem}
        onHide={handleCloseAddOptionItem}
        centered
        size="lg"
      >
        <Modal.Header className="px-lg-5 pt-lg-5 border-0" closeButton>
          <Modal.Title className="f18-700">Add On Option Item</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-lg-5 pb-lg-5 new-subscription-onboarding-component">
          <Form>
            <Row>
              <Col lg={10}>
                <NewInputText
                  controlClass={"nameA"}
                  labelText="Item Name"
                  extraClass={`mb-1 ${
                    formikAddOptions.errors.name &&
                    formikAddOptions.touched.name
                      ? "enError"
                      : ""
                  }`}
                  name="name"
                  onChange={formikAddOptions.handleChange}
                  value={formikAddOptions.values.name}
                  onFocusOut={formikAddOptions.handleBlur}
                />
                {formikAddOptions.errors.name &&
                formikAddOptions.touched.name ? (
                  <div className="pho_14_regular text-danger mb-2">
                    {formikAddOptions.errors.name}
                  </div>
                ) : (
                  <div className="mb-2"></div>
                )}
              </Col>
            </Row>
            <div className="f16-700 pb-3">
              Is this Item Available in One Size or Multiple Sizes?
            </div>
            <div className="d-flex align-items-center pb-4">
              <label className="enRadioWithText small mr-4">
                <div className="f13-500">One Size</div>
                <input
                  type="radio"
                  name="one_size"
                  checked={formikAddOptions.values.one_size === false}
                  onChange={() => onChangeSize(false)}
                />
                <span className="checkmark"></span>
              </label>
              <label className="enRadioWithText small mr-4">
                <div className="f13-500">Multiple Size</div>
                <input
                  type="radio"
                  name="one_size"
                  checked={formikAddOptions.values.one_size === true}
                  onChange={() => onChangeSize(true)}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <Row>
              <Col lg={5} md={7}>
                <NewInputText
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputType="number"
                  controlClass={"price"}
                  labelText="Item Price"
                  extraClass={`mb-2 ${
                    formikAddOptions.errors.price &&
                    formikAddOptions.touched.price
                      ? "enError"
                      : ""
                  }`}
                  name="price"
                  onChange={formikAddOptions.handleChange}
                  value={formikAddOptions.values.price}
                  onFocusOut={formikAddOptions.handleBlur}
                />
                {formikAddOptions.errors.price &&
                formikAddOptions.touched.price ? (
                  <div className="pho_14_regular text-danger mb-2">
                    {formikAddOptions.errors.price}
                  </div>
                ) : (
                  <div className="mb-2"></div>
                )}{" "}
              </Col>
            </Row>
            <div className="f16-700 pb-3">Is this veg or Non Veg?</div>
            <div className="d-flex align-items-center pb-4">
              <label className="enRadioWithText small mr-4">
                <div className="f13-500">Veg</div>
                <input
                  type="radio"
                  name="veg"
                  checked={formikAddOptions.values.veg === true}
                  onChange={() => onChangeVegNon(true)}
                />
                <span className="checkmark"></span>
              </label>
              <label className="enRadioWithText small mr-4">
                <div className="f13-500">Non Veg/Egg/Other</div>
                <input
                  type="radio"
                  name="veg"
                  checked={formikAddOptions.values.veg === false}
                  onChange={() => onChangeVegNon(false)}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="f16-700 pb-3">Food Type</div>
            <div className="mb-4 d-flex flex-wrap">
              {foodType.map((icon, index) => (
                <div
                  className="column4 enCheckWithText smallCenter"
                  key={index}
                >
                  <input
                    type="radio"
                    name="foodType"
                    checked={formikAddOptions.values.food_type === icon._id}
                    onChange={() => onChangeFoodType(icon._id)}
                  />
                  <label className="w-100 d-flex align-items-center justify-content-center">
                    {icon.title}
                  </label>
                </div>
              ))}
            </div>
            {formikAddOptions.errors.food_type &&
            formikAddOptions.touched.food_type ? (
              <div className="pho_14_regular text-danger">
                {formikAddOptions.errors.food_type}
              </div>
            ) : null}
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
                Nutritional Information
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formikAddOptions.values.nutritional_info}
                  onChange={() => onChangeNutrutionalInfo()}
                />
              </div>
            </div>
            {formikAddOptions.values.nutritional_info ? (
              <Row>
                <Col lg={5} md={7}>
                  <NewInputText
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    controlClass={"calories"}
                    labelText="Calories"
                    extraClass="mb-4"
                    extraClass={`mb-3 ${
                      formikAddOptions.errors.calories &&
                      formikAddOptions.touched.calories
                        ? "enError"
                        : ""
                    }`}
                    name="calories"
                    onChange={formikAddOptions.handleChange}
                    value={formikAddOptions.values.calories}
                    onFocusOut={formikAddOptions.handleBlur}
                  />
                  {formikAddOptions.errors.calories &&
                  formikAddOptions.touched.calories ? (
                    <div className="pho_14_regular text-danger">
                      {formikAddOptions.errors.calories}
                    </div>
                  ) : null}
                </Col>
              </Row>
            ) : (
              <> </>
            )}
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
                Allergy Information
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formikAddOptions.values.allergy_info}
                  onChange={() => onChangeAllergyInfo()}
                />
              </div>
            </div>
            {formikAddOptions.values.allergy_info ? (
              <>
                {allergyInfo.map((icon, index) => (
                  <div className="column4 enCheckWithText small" key={index}>
                    <input
                      type="checkbox"
                      name="allergyInformation"
                      checked={formikAddOptions.values.allergies.includes(
                        icon.title
                      )}
                      onChange={() => onChangeAddRemoveAllergy(icon.title)}
                    />
                    <label className="w-100 d-flex align-items-center">
                      <img width="20px" height="20px" src={icon.icon} />
                      <span className="pl-2">{icon.title}</span>
                    </label>
                  </div>
                ))}
              </>
            ) : (
              <> </>
            )}
            {formikAddOptions.errors.allergies &&
            formikAddOptions.touched.allergies ? (
              <div className="pho_14_regular text-danger">
                {formikAddOptions.errors.allergies}
              </div>
            ) : null}
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn150px btn btn-outline-secondary"
                buttonText="Cancel"
                buttonType="button"
                onClick={handleCloseAddOptionItem}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn150px btn btn-danger btn-lg ml-3 "
                buttonText="Save"
                buttonType="button"
                //onClick={handleCloseAddOptionItem}
                onClick={(e) => onClickSave(e)}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        show={showCustomizedTemplates}
        onHide={handleCloseCustomizedTemplates}
        centered
        size="lg"
      >
        <Modal.Header className="px-lg-5 pt-lg-5 border-0" closeButton>
          <Modal.Title className="f18-700">Customized Templates</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-lg-5 pb-lg-5">
          <div
            className="d-flex f14-700 justify-content-between ml-5 mr-5"
            style={{ color: "rgba(0, 0, 0, 0.54)" }}
          >
            <div
              style={{ color: "#c82333", borderBottom: "1px solid #c82333" }}
            >
              My Templates
            </div>
            <div>Chain Templates</div>
            <div>Global Templates</div>
          </div>
          <hr />
          <Form>
            <div className="f16-700 pb-1">Select Template</div>
            <Row>
              <Col lg={7}>
                <FormControl variant="outlined" className={"w-100 mb-3"}>
                  <InputLabel htmlFor="outlined-SelectTemplate">
                    Select Template
                  </InputLabel>
                  <Select
                    value={state.SelectTemplate}
                    label=" Select Template"
                    onChange={selecthandleChange}
                    inputProps={{
                      name: "SelectTemplate",
                      id: "outlined-SelectTemplate",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {vendorAllTemplates.map((item, index) => (
                      <option key={index} value={item._id}>
                        {item.name}{" "}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Col>
            </Row>
            <Row>
              {templateOptionsData.map((data, index) => (
                <Col lg={4} md={6} key={index}>
                  <div className="d-flex align-items-center pb-3">
                    <Form.Check
                      label="1"
                      inline
                      className="enCheckBoxOnly d-grid"
                      checked={data.value}
                      onChange={() => onChangeAddCheck(data._id, data.value)}
                    />
                    <SVG
                      width="16px"
                      height="16px"
                      src={
                        data.veg
                          ? require("../../../../../../../../assets/images/UserManagement/veg.svg")
                          : require("../../../../../../../../assets/images/UserManagement/nonveg.svg")
                      }
                    />
                    <div
                      className="f12-500 pl-2 text-break"
                      style={{ width: 125 }}
                    >
                      {data.name}
                    </div>
                    <input
                      disabled
                      type="number"
                      placeholder="Value"
                      className="enPriceInput"
                      value={data.price}
                    />
                  </div>
                </Col>
              ))}
            </Row>

            <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
              <div>
                <ReusableOnboardingButton
                  buttonTitle="Back"
                  buttonClass="btn-lg btn150px btn btn-outline-secondary"
                  buttonText="Cancel"
                  buttonType="button"
                  onClick={handleCloseCustomizedTemplates}
                />
                <ReusableOnboardingButton
                  buttonTitle="Done"
                  buttonClass="btn-lg btn150px btn btn-danger btn-lg ml-3 "
                  buttonText="Done"
                  buttonType="button"
                  //onClick={handleCloseCustomizedTemplates}
                  onClick={(e) => onClickDone(e)}
                />
              </div>
              <AddButtonIconComponent
                buttonText="Add Another Choice"
                fontIcon="fa fa-plus"
                colorCss="blue"
                type={"button"}
                onClick={handleAddOptionItem}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

Customization.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
  get_vendor_added_templates: PropTypes.func.isRequired,
  add_new_template_vendor: PropTypes.func.isRequired,

  add_new_choice_template_vendor: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  menuCategoryItems: state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding.activeItemId,
  vendor_templates: state.onboarding.vendor_templates,
  food_type: state.category.foodtype,
  allergy_info: state.category.allergy_info,
});

export default connect(mapStateToProps, {
  update_item_menu_setup,
  get_vendor_added_templates,
  add_new_template_vendor,
  add_new_choice_template_vendor,
})(Customization);
